import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import QuickSummarySection from "@/components/QuickSummarySection";
import AcademyContentSection from "@/components/AcademyContentSection";
import BenefitsSection from "@/components/BenefitsSection";
import ToolsSection from "@/components/ToolsSection";
import CommunitySection from "@/components/CommunitySection";
import DifferentiatorSection from "@/components/DifferentiatorSection";
import ProviderSection from "@/components/ProviderSection";
import PlansSection from "@/components/PlansSection";
import LeadForm from "@/components/LeadForm";
import FAQSection from "@/components/FAQSection";
import ClosingBlock from "@/components/ClosingBlock";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function LandingPage() {
  // Update meta tags for SEO
  useEffect(() => {
    document.title = "Ruta de Ecommerce Estructurada | DSA - Orientación Comercial";
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = "Conoce una ruta de Ecommerce más estructurada con contenido organizado, herramientas complementarias y comunidad. Programa educativo provisto por MINED. Orientación comercial por DSA.";

    // Update OG tags
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.content = "Ruta de Ecommerce Estructurada | DSA";

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.content = "Evalúa una propuesta educativa de Ecommerce con contenido estructurado, herramientas y comunidad. Programa por MINED, orientación por DSA.";
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen">
      <Navigation />
      
      {/* 1. Hero Premium de dos columnas */}
      <HeroSection />
      
      {/* 2. Quick Summary - 5 indicadores visuales */}
      <QuickSummarySection />
      
      {/* 3. Qué incluye esta ruta - Módulos */}
      <section id="contenido">
        <AcademyContentSection />
      </section>
      
      {/* 4. Qué recibes al avanzar - Beneficios */}
      <BenefitsSection />
      
      {/* 5. Tools Section - Herramientas complementarias */}
      <ToolsSection />
      
      {/* 6. Community Section - Entorno de aprendizaje */}
      <CommunitySection />
      
      {/* 7. Differentiator - Comparativa */}
      <DifferentiatorSection />
      
      {/* 8. Provider Section - MINED como proveedor */}
      <ProviderSection />
      
      {/* 9. Plans Section - Modalidades de acceso */}
      <PlansSection />
      
      {/* Lead Form - Formulario de captación */}
      <LeadForm />
      
      {/* 10. FAQ Section */}
      <FAQSection />
      
      {/* 11. Closing Block - Cierre final */}
      <ClosingBlock />
      
      {/* 12. Footer con aviso legal y política de privacidad */}
      <Footer />
      
      {/* Floating WhatsApp Button */}
      <WhatsAppButton />
    </div>
  );
}
